import { ComponentProps, FC } from 'react'
import { config, styled } from '../../config'
import { AlertContext, ColorSchemes } from './AlertContext'
import { AlertStatus } from './types'

const Root = styled('div', {
  display: 'flex',
  padding: '16px',
  borderRadius: '12px',
  alignItems: 'center'
})

export interface AlertProps {
  status?: AlertStatus
}

/**
 * Exports 4 related components that are grouped together.
 * Alert (the wrapper for alert components), AlertTitle, AlertDescription and AlertIcon.
 * The color scheme is driven by the status prop.
 */
export const Alert: FC<ComponentProps<typeof Root> & AlertProps> = ({
  status = 'info',
  children,
  css,
  ...rest
}) => {
  const colorScheme = ColorSchemes[status]

  return (
    <AlertContext.Provider value={{ status, colorScheme }}>
      <Root
        css={{ backgroundColor: config.theme.colors[colorScheme.backgroundColor], ...css }}
        {...rest}
      >
        {children}
      </Root>
    </AlertContext.Provider>
  )
}
